"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _notificationsListModule = _interopRequireDefault(require("./notificationsList.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotificationsList =
/*#__PURE__*/
function (_Component) {
  _inherits(NotificationsList, _Component);

  function NotificationsList(props) {
    var _this;

    _classCallCheck(this, NotificationsList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationsList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onDismiss", function (key) {
      _this.setState(_objectSpread({}, _this.state, {
        hiddenItems: [].concat(_toConsumableArray(_this.state.hiddenItems), [key])
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "mapPositionToClass", function (position) {
      if (position === 'topCenter') {
        return _notificationsListModule.default["top-center"];
      }

      if (position === 'topRight') {
        return _notificationsListModule.default["top-right"];
      }

      if (position === 'bottomCenter') {
        return _notificationsListModule.default["bottom-center"];
      }

      if (position === 'centerLeft') {
        return _notificationsListModule.default["center-left"];
      }

      return "";
    });

    _defineProperty(_assertThisInitialized(_this), "mapVariantToClass", function (variant) {
      if (variant === "error") {
        return _notificationsListModule.default["alert-danger"];
      }

      if (variant === "success") {
        return _notificationsListModule.default["alert-success"];
      }

      if (variant === "info") {
        return _notificationsListModule.default["alert-info"];
      }

      if (variant === "warning") {
        return _notificationsListModule.default["alert-warning"];
      }

      if (variant === "warning_pale") {
        return _notificationsListModule.default["alert-warning-pale"];
      }

      return _notificationsListModule.default["alert-info"];
    });

    _this.state = {
      hiddenItems: []
    };
    return _this;
  }

  _createClass(NotificationsList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          position = _this$props.position,
          notifications = _this$props.notifications,
          variant = _this$props.variant,
          customStyle = _this$props.customStyle;
      var positionClassName = this.mapPositionToClass(position);
      var variantMapping = this.mapVariantToClass(variant);
      return _react.default.createElement("div", {
        id: id ? id : null,
        className: (0, _classnames.default)(_themeModule.default.arag, _notificationsListModule.default["notifications-list"], positionClassName, _notificationsListModule.default.fade, _notificationsListModule.default.in),
        style: customStyle
      }, notifications.filter(function (notification) {
        return !_this2.state.hiddenItems.includes(notification.key);
      }).map(function (notification) {
        return _react.default.createElement("div", {
          id: id ? "".concat(id, "_notification_item_").concat(notification.key) : null,
          key: notification.key,
          className: (0, _classnames.default)(_notificationsListModule.default.alert, _notificationsListModule.default["alert-dismissible"], notification.variant ? _this2.mapVariantToClass(notification.variant) : variantMapping)
        }, _react.default.createElement("button", {
          id: id ? "".concat(id, "_notification_item_").concat(notification.key, "_button") : null,
          type: "button",
          className: _notificationsListModule.default.close,
          "data-dismiss": "alert",
          onClick: function onClick() {
            if (notification.callback) {
              notification.callback(notification);
            } else {
              _this2.onDismiss(notification.key);
            }
          }
        }, "\xD7"), _react.default.createElement("p", {
          id: id ? "".concat(id, "_notification_item_").concat(notification.key, "_label") : null
        }, _react.default.createElement("small", null), notification.label));
      }));
    }
  }]);

  return NotificationsList;
}(_react.Component);

NotificationsList.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** The position of the notifications list */
  position: _propTypes.default.oneOf(["topRight", "centerLeft", "topCenter", "bottomCenter"]),

  /** The variant of the notifications list */
  variant: _propTypes.default.oneOf(["error", "success", "info"]),

  /** Custom style object */
  customStyle: _propTypes.default.object,

  /** The notification item */
  notifications: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    variant: _propTypes.default.oneOf(["error", "success", "info"]),
    callback: _propTypes.default.func
  }))
};
var _default = NotificationsList;
exports.default = _default;